// removed by extract-text-webpack-plugin
module.exports = {"main":"_3Vsam9QgooSXCcHQkf7DFP","overlay":"UYQvp6KbS5YA-DXpIjQ_X"};


//////////////////
// WEBPACK FOOTER
// ./src/projects/easy/public/Comps/basic/Popup.scss
// module id = 695
// module chunks = 12